import postPosition from './post-position'
import { has, isArray, isFinite, castArray, conformsTo } from 'lodash-es'

const FIELD = 'modelIndex'
const PRE_FIELD = 'modelPreIndex'

export default {
  clear,
  index,
  preIndex,

  diffAsc,
  diffDesc,

  _hasIndexField,
  _hasIndex,
  _hasPreIndexField,
  _hasPreIndex
}

let aboveCount = +1
let belowCount = -1

function _hasIndexField(post) {
  return has(post, FIELD)
}

function _hasIndex(post) {
  return _hasIndexField(post) && isFinite(post[FIELD])
}

function _hasPreIndexField(post) {
  return has(post, PRE_FIELD)
}

function _hasPreIndex(post) {
  return _hasPreIndexField(post) && conformsTo(post[PRE_FIELD], {
    above: isFinite,
    below: isFinite
  })
}

function clear(post) {
  if (isArray(post)) {
    post.forEach(clear)
  } else {
    delete post[FIELD]
  }

  return post
}

function index(input) {
  const posts = castArray(input)

  for (let index = 0, length = posts.length; index !== length; index++) {
    const post = posts[index]

    if (!postPosition.isBelow(post)) {
      continue
    }

    if (_hasPreIndexField(post)) {
      post[FIELD] = post[PRE_FIELD].below
      delete post[PRE_FIELD]
    } else {
      post[FIELD] = belowCount--
    }
  }

  for (let index = posts.length - 1; index !== -1; index--) {
    const post = posts[index]

    if (!postPosition.isAbove(post)) {
      continue
    }

    if (_hasPreIndexField(post)) {
      post[FIELD] = post[PRE_FIELD].above
      delete post[PRE_FIELD]
    } else {
      post[FIELD] = aboveCount++
    }
  }

  return input
}

function preIndex(input) {
  const posts = castArray(input)

  for (let index = 0, length = posts.length; index !== length; index++) {
    const post = posts[index]
    post[PRE_FIELD] = {
      below: belowCount--,
      above: aboveCount++
    }
  }

  return input
}

function diffAsc(a, b) {
  const mainDiff = a[FIELD] - b[FIELD]

  if (mainDiff !== 0) {
    return mainDiff
  }

  return a.id - b.id
}

function diffDesc(a, b) {
  const mainDiff = b[FIELD] - a[FIELD]

  if (mainDiff !== 0) {
    return mainDiff
  }

  return b.id - a.id
}
